import { createApi } from '@/api/modules/utils'

const baseUrl = '/media_platform'
const api = createApi(baseUrl)

// 媒体平台
export const mediaPlatformApi = {
    list: api('list', 'get'),
    binding: api('binding', 'get'),
}